/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { withRouter } from "react-router-dom";

import Constants from "app_constants";
import Theme from "./theme";

import work from "assets/img/work.jpg";

const About = (props) => {
  const [showContent, setShowContent] = useState(false);

  return (
    <Theme>
      {Constants.metaTag}

      <div className="columns">
        <div className="column is-half-desktop">
          <img onLoad={() => setShowContent(true)} src={work} />
        </div>

        {showContent && (
          <div className="content column is-half-desktop">
            <b>
              Remote Jobs is a platform to find and list remote-only jobs world
              wide.
            </b>
            <br /> <br />
            <p>
              Its' user friendly interface allows users to browse job
              opportunities from the most remote-friendly companies in the
              world. Companies can create remote job posts and find the right
              candidates easily.
            </p>
            <br />
            <p>
              "Remote Jobs" platform matches the most suitable candidates with
              the most suitable remote job adverts.
            </p>
            <p>
              <b>Do you want to ask something?</b>
            </p>
            <button
              onClick={() => {
                props.history.push("/contact");
                window.scrollTo(0, 0);
              }}
              className="button is-info is-rounded"
            >
              <span className="icon is-small">
                <i className="fas fa-envelope"></i>
              </span>
              <span>Contact Us</span>
            </button>
          </div>
        )}
      </div>
    </Theme>
  );
};

export default withRouter(About);
